import { defineMessages } from 'react-intl';

export default defineMessages({
  ALERT_CONTENT: {
    defaultMessage:
      'En raison d’un transfert de données, certaines statistiques de progression peuvent présenter un léger écart. Merci de votre compréhension.',
  },

  UNDERSTOOD: {
    defaultMessage: 'J’ai compris',
  },
} as const);
